// composables/useSnackbar.ts
import { reactive } from 'vue'

export type SnackbarType = 'success' | 'error' | 'warning' | 'info'

interface SnackbarState {
  visible: boolean
  message: string
  color: string
  timeout: number
}

const state = reactive<SnackbarState>({
  visible: false,
  message: '',
  color: 'success',
  timeout: 3000,
})

export function useSnackbar() {
  const show = (message: string, color: string = 'success', timeout: number = 3000) => {
    state.message = message
    state.color = color
    state.timeout = timeout
    state.visible = true
  }

  const hide = () => {
    state.visible = false
  }

  // Convenience methods
  const success = (message: string, timeout?: number) => show(message, 'success', timeout)

  const error = (message: string, timeout?: number) => show(message, 'error', timeout)

  const warning = (message: string, timeout?: number) => show(message, 'warning', timeout)

  const info = (message: string, timeout?: number) => show(message, 'info', timeout)

  return {
    state,
    show,
    success,
    error,
    warning,
    info,
    hide,
  }
}

// Global instance for use outside composables
export const globalSnackbar = {
  success: (message: string, timeout?: number) => {
    const { success } = useSnackbar()
    return success(message, timeout)
  },
  error: (message: string, timeout?: number) => {
    const { error } = useSnackbar()
    return error(message, timeout)
  },
  warning: (message: string, timeout?: number) => {
    const { warning } = useSnackbar()
    return warning(message, timeout)
  },
  info: (message: string, timeout?: number) => {
    const { info } = useSnackbar()
    return info(message, timeout)
  },
}
